import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { CalendarView, ProjectsView } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";

export const useIsSmartPlannerView = (): boolean => {
  const calendarRoot = useCalendarRoot();
  const workforceView = useBookingModuleStore((state) => state[CalendarRoot.WorkforceProfiles].view);
  const projectsEngagementsView = useBookingModuleStore(
    (state) => state[CalendarRoot.ProjectsEngagements].view
  );
  const projectsRolesView = useBookingModuleStore((state) => state[CalendarRoot.ProjectsRoles].view);

  if (isWorkforceProfiles(calendarRoot)) {
    return workforceView === CalendarView.Grid;
  }

  if (calendarRoot === CalendarRoot.ProjectsEngagements) {
    return projectsEngagementsView === ProjectsView.Grid;
  }

  if (calendarRoot === CalendarRoot.ProjectsRoles) {
    return projectsRolesView === ProjectsView.Grid;
  }

  return false;
};
